const handleHeaderDropdowns = () => {
    const $nav = $('.navigation');
    const $dropdown = $nav.find('li.has-dropdown');

    $dropdown.append('<span class="navigation__menu-trigger js-dropdown-trigger"></span>');
    const $dropdownTrigger = $dropdown.find('.js-dropdown-trigger');

    $dropdownTrigger.on('click', function (event) {
        const $this = $(this);
        const $parent = $this.parent();

        if ($(window).width() > 1023) {
            return
        } else {
            event.preventDefault();

            $parent.toggleClass('is-active');

            $parent.find('.mega-menu, .nav-dropdown')
                .stop()
                .slideToggle()
                .parent()
                .siblings()
                .removeClass('is-active')
                .find('> div')
                .slideUp();
        }
    });
};

handleHeaderDropdowns();
